import MConfirmBtn from './ConfirmBtn.vue';

export default MConfirmBtn;
